import { defaultTheme } from "waapi/waap-ui/components/Theme/Theme.constants.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";

const isMac = (): boolean => {
    return navigator.platform.indexOf("Mac") > -1 || navigator.userAgent.indexOf("Mac") > -1;
};

export const lightTheme: ITheme = { ...defaultTheme, customScrollbars: !isMac() };
